import { RoleId } from '@common/constants';
import type { UserWithLawFirm } from '@common/types/users';
import type { AxiosResponse } from 'axios';
import { create } from 'zustand';
import { fetchCurrentUser } from '@/services/IdentityService';

interface UseIdentityStoreType {
    user: UserWithLawFirm | null;
    isSuperAdmin: boolean;
    myLawFirmId: number | undefined;
    fetchUserFromServer(): Promise<AxiosResponse<UserWithLawFirm>>;
}
const useIdentityStore = create<UseIdentityStoreType>((set, _get) => ({
    user: null,
    isSuperAdmin: false,
    myLawFirmId: undefined,
    fetchUserFromServer: async () => {
        const response = await fetchCurrentUser();
        const user = response.data;
        set((state) => ({
            ...state,
            user,
            isSuperAdmin: !!user?.roles?.some((role) => role.roleId === RoleId.SUPER_ADMIN),
            myLawFirmId: user?.lawFirm?.lawFirmId ?? user?.lawFirmId ?? undefined,
        }));
        return response;
    },
}));

export default useIdentityStore;
